export default {
    menu: {
        concursos: "Concursos",
        lotes: "Lotes",
        ofertas: "Ofertas",
        licitadores: "Licitadores",
        informes: "informes"
    },
    buttons: {
        detalles: "Detalles",
        crear: "Crear",
        eliminar: "Eliminar",
        cancelar: "Cancelar",
        aceptar: "Aceptar",
        añadir: "Añadir",
    },
    languages:{
        title: "Idioma",
        spanish: "Español",
        english: "Inglés",
        selected: "Seleccionado"
    },
    user:{
        logout: "Cerrar sesión",
        profile: "Cambiar contraseña",
        account: "Cuenta"
    },
    concursos: {
        nuevo: "Nuevo concurso",
        editar: "Editar concurso",
        consultar: "Consultar concursos"
    },
    lotes: {
        nuevo: "Nuevo lote",
        consultar: "Consultar lotes",
        detalles: "Detalles del lote"
    },
    ofertas: {
        nuevo: "Nueva oferta",
        consultar: "Consultar ofertas"
    },
    licitadores: {
        nuevo: "Nuevo licitador",
        consultar: "Consultar licitadores",
        detalles: "Detalles del licitador"
    },
    informes: {
        nuevo: "Nuevo informe",
        consultar: "Lista de informes"
    },

};